export interface Asset {
	AssetId: number;
	AssetName: string;
	CanBeDefaultAsset: boolean;
	ParentAssetId: number | null;
	IsAsset: boolean;
	IsLeaf: boolean | null;
	ParentAssetName?: string | null;
	IsBranch: boolean;
}

export const ASSET_INITIAL_VALUES: Asset = {
	AssetId: 0,
	AssetName: "",
	CanBeDefaultAsset: false,
	ParentAssetId: 0,
	IsAsset: false,
	IsLeaf: null,
	ParentAssetName: "",
	IsBranch: false,
};
